import { Box, Skeleton, Typography, Paper } from "@mui/material";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const COLORS = [
  "#8884d8",
  "#82ca9d",
  "#ffc658",
  "#ff7c7c",
  "#8dd1e1",
  "#d084d0",
  "#82d982",
  "#ffb347",
];

const RepOrderTrendChart = ({ data, isLoading, error }) => {
  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (isLoading || !data) {
    return (
      <Skeleton
        variant="rectangular"
        height={300}
      />
    );
  }

  if (!data || data.length === 0) {
    return (
      <Box
        sx={{
          height: 300,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography color="textSecondary">No data available</Typography>
      </Box>
    );
  }

  // Group data by date and build chart structure
  const dateMap = {};
  const reps = new Set();

  data.forEach((item) => {
    reps.add(item._id.userId);
    if (!dateMap[item._id.date]) {
      dateMap[item._id.date] = { date: item._id.date };
    }
    dateMap[item._id.date][item._id.userId] = item.value;
  });

  const chartDataArray = Object.values(dateMap).sort((a, b) =>
    a.date.localeCompare(b.date)
  );

  const repsArray = Array.from(reps);
  const chartData = {
    labels: chartDataArray.map((item) => item.date),
    datasets: repsArray.map((repId, index) => ({
      label: `Rep ${index + 1}`,
      data: chartDataArray.map((item) => item[repId] || 0),
      borderColor: COLORS[index % COLORS.length],
      backgroundColor: `${COLORS[index % COLORS.length]}20`,
      tension: 0.4,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: "Rep Order Value Trends",
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Value ($)",
        },
      },
    },
  };

  return (
    <Paper sx={{ p: 2, height: 400 }}>
      <Line
        data={chartData}
        options={options}
      />
    </Paper>
  );
};

export default RepOrderTrendChart;
